import languageTypes from "../actionTypes";
import CacheUtils from "utils/CacheUtils";
import openApi from "services/apis/openApi";

export function localizationLanguageAction(languageCode) {
  return async function (dispatch) {
    try {
      dispatch({
        type: languageTypes.LANGUAGE,
        payload: {
          isLoading: true,
        },
      });
      let languageJsonData = undefined;
      const cachedData = await CacheUtils.getCacheResponseTTL(
        "languageCache",
        "languageJsonData"
      );
      if (cachedData) {
        languageJsonData = cachedData;
      } else {
        const response = await openApi.getLocalizationLanguageDetailByCode({
          languageCode,
        });
        languageJsonData = response?.data?.languageJson;
        CacheUtils.cacheResponseTTL(
          "languageCache",
          "languageJsonData",
          languageJsonData,
          120
        );
      }

      dispatch({
        type: languageTypes.LANGUAGE,
        payload: {
          languageCodeData: languageJsonData,
        },
      });
      dispatch({
        type: languageTypes.LOADING,
        payload: {
          isLoading: false,
        },
      });
      return languageJsonData;
    } catch (error) {
      dispatch({
        type: languageTypes.LOADING,
        payload: {
          isLoading: false,
        },
      });
      throw error;
    }
  };
}
